import {getMockProtocolVersionDetailsV2} from '../../../../../api/endpoints/mockData';
import {
  IGetAIReviewJobDetailsResponse,
  ProtocolVersionDetailsResponseV2,
} from '../../../../../api/types/aiReview.type';
import {
  CaseContext,
  IssueCoding,
  RelevanceCriteria,
} from '../../../../../redux/slice/aiReviewSliceV2';

export interface JobDetailsArtifacts {
  caseContext: CaseContext;
  issueCoding: IssueCoding;
  relevanceCriteria: RelevanceCriteria;
}

const MOCK_VERSION_ID = 1;

export const resolveJobDetailsArtifacts = (
  jobDetails?: IGetAIReviewJobDetailsResponse | null,
  protocolVersion?: ProtocolVersionDetailsResponseV2 | null
): JobDetailsArtifacts | null => {
  if (!jobDetails) {
    return null;
  }

  if (protocolVersion) {
    return {
      caseContext: protocolVersion.caseContext,
      issueCoding: protocolVersion.issueCoding,
      relevanceCriteria: protocolVersion.relevanceCriteria,
    };
  }

  if (
    jobDetails.structuredCaseContext ||
    jobDetails.structuredIssueCoding ||
    jobDetails.structuredRelevanceCriteria
  ) {
    const mock = getMockProtocolVersionDetailsV2(MOCK_VERSION_ID);
    return {
      caseContext: jobDetails.structuredCaseContext ?? mock.caseContext,
      issueCoding: jobDetails.structuredIssueCoding ?? mock.issueCoding,
      relevanceCriteria:
        jobDetails.structuredRelevanceCriteria ?? mock.relevanceCriteria,
    };
  }

  const mock = getMockProtocolVersionDetailsV2(MOCK_VERSION_ID);
  return {
    caseContext: mock.caseContext,
    issueCoding: mock.issueCoding,
    relevanceCriteria: mock.relevanceCriteria,
  };
};
